if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        if (field.hasAttribute("data-fine-lov-nav")) return;

        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        if (field.hasAttribute("data-fine-lov-nav")) return;

        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        if (field.hasAttribute("data-fine-lov-nav")) return;

        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    updateSwatchDropdownIndicators() {
      this.querySelectorAll(
        ".m-product-option--swatch_dropdown select, .m-product-option--dropdown select"
      ).forEach((select) => {
        const content = select.closest(".m-product-option--content");
        if (!content) return;

        const selected = select.selectedOptions[0];
        const swatch = selected && selected.dataset.optionSwatchValue;
        const focal = selected && selected.dataset.optionSwatchFocalPoint;

        if (swatch) {
          content.style.setProperty("--variant-swatch-color", swatch);
          if (focal) {
            content.style.setProperty("--variant-swatch-focal-point", focal);
          } else {
            content.style.removeProperty("--variant-swatch-focal-point");
          }
        } else {
          content.style.removeProperty("--variant-swatch-color");
          content.style.removeProperty("--variant-swatch-focal-point");
        }
      });
    }

    handleFineLovNavigation(select) {
      const selected = select.selectedOptions[0];
      const url = selected && (selected.dataset.productUrl || selected.value);
      if (!url) return false;

      try {
        const next = new URL(url, window.location.origin);
        const current = new URL(window.location.href);
        if (next.pathname === current.pathname) {
          this.updateSwatchDropdownIndicators();
          return true;
        }
        window.location.assign(next.pathname + next.search + next.hash);
        return true;
      } catch (e) {
        window.location.assign(url);
        return true;
      }
    }

    connectedCallback() {
      this.updateSwatchDropdownIndicators();
      this.addEventListener("change", (event) => {
        const select =
          event.target && event.target.closest
            ? event.target.closest("[data-fine-lov-nav]")
            : null;
        if (select || (event.target && event.target.hasAttribute && event.target.hasAttribute("data-fine-lov-nav"))) {
          const lovSelect = select || event.target;
          if (this.handleFineLovNavigation(lovSelect)) return;
        }

        this.updateSwatchDropdownIndicators();
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, {
          data: {
            selectedOptionValues: this.selectedOptionValues,
            event,
            target,
          },
        });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}
